<template>
  <div class="flex h-full flex-col">
    <TabGroup
      :default-index="defaultIndex"
      :selected-index="selectedIndex"
      :manual="manual"
      @change="handleChange"
    >
      <slot />
    </TabGroup>
  </div>
</template>

<script setup lang="ts">
import { TabGroup } from '@headlessui/vue';

type Props = {
  /** The default tab index to show initially */
  defaultIndex?: number;
  /** Controlled selected index for external control */
  selectedIndex?: number;
  /** Whether tabs are displayed vertically */
  vertical?: boolean;
  /** Whether tab activation requires manual selection (not automatic on focus) */
  manual?: boolean;
};

type Emits = {
  /** Emitted when the selected tab changes */
  change: [index: number];
};

withDefaults(defineProps<Props>(), { defaultIndex: 0 });
const emit = defineEmits<Emits>();

function handleChange(index: number): void {
  emit('change', index);
}
</script>
